/**
 * Stato dell'avviso "novità non lette".
 *
 * Sorgente unica: LATEST_NEWS va aggiornato quando si aggiunge una voce in
 * ChangelogPage (stesso id e stessa data della prima voce dell'elenco).
 *
 * L'avviso compare per WINDOW_DAYS giorni dalla data della novità e scompare
 * se l'utente visita la pagina Novità (letto) o chiude la X (rifiutato).
 * Le chiavi includono l'id: alla prossima novità l'avviso ricompare da solo.
 */
export const LATEST_NEWS = {
  id: '2026-11-priceArchive',
  date: '2026-11-01',
  count: 2,
};

export const WINDOW_DAYS = 10;

const SEEN_KEY = 'scanmarket_news_seen';
const DISMISS_KEY = 'scanmarket_news_dismissed';

const read = (key) => {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

const write = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch { /* storage non disponibile: pazienza */ }
};

/** La novità è ancora "fresca"? (entro la finestra di giorni) */
export function isNewsFresh(now = Date.now()) {
  const published = new Date(`${LATEST_NEWS.date}T00:00:00Z`).getTime();
  if (Number.isNaN(published)) return false;
  return now >= published - 12 * 3600 * 1000
    && now <= published + WINDOW_DAYS * 24 * 3600 * 1000;
}

/** Mostrare il puntino / il banner? */
export function hasUnreadNews(now = Date.now()) {
  if (!isNewsFresh(now)) return false;
  return read(SEEN_KEY) !== LATEST_NEWS.id && read(DISMISS_KEY) !== LATEST_NEWS.id;
}

/** L'utente ha aperto la pagina Novità. */
export function markNewsSeen() {
  write(SEEN_KEY, LATEST_NEWS.id);
  // Il puntino nell'header ascolta questo evento e si spegne subito.
  try {
    window.dispatchEvent(new Event('scanmarket:news-seen'));
  } catch { /* ambiente non-browser */ }
}

/** L'utente ha chiuso l'avviso con la X. */
export function dismissNews() {
  write(DISMISS_KEY, LATEST_NEWS.id);
}
